/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-08 11:11:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-06 10:59:33
 */
import React, {PureComponent, Fragment} from 'react'
import {connect} from 'react-redux'
import Axios from 'axios'
// import {Helmet} from "react-helmet"
// import { Carousel } from 'antd';
// import Footer from '../../Footer/index'
import './index.css'
import './style.css'
import {Button, Input, message} from 'antd'
import {SearchOutlined} from '@ant-design/icons';
// import Header4 from '../../Header/Header4'
import Header4 from '../../Header/Header4'
import {getNotice, getTraning} from './service/action'
import {Link} from 'react-router-dom'
import {transformtime} from 'src/utils/tools'

import OnlineService from '../../OnlineService/index'
import Globe from '../../Globe/index'
import GlobeTool from '../../GlobeTool/index'
import {
    MenuCard,
    ResourcesCollectCard,
    CultivateKnowledgeCard,
    ResourcesShareCard,
    TechnologyServiceCard,
    MainBottom,
    DigitalScrolling
} from './component/index'
import GuideCarousel from './GuideCarousel';
import {
    homePageImg, menuCardList, resourcesCollectCardList, resourcesCollectLastCardList,
    cultivateKnowledgeCardList, resourcesShareCardList, technologyServiceCardList, unitsList,
    noticeDatas, newsDatas, statisticsDatas, introduceDatas,
} from './component/Datas/normalDatas'
import {
    searchAdminDivisionJson_zd,
    getPositionsFromAdminDivisionData_zd
} from 'src/components/Pages/GeovisResource/service/actoin';
import axios from "axios";
import {login, logout} from 'src/service/loginaction_yunguan'
import {param} from 'jquery'

const {Search} = Input;
const menus = [
    {
        name: '真实性检验站'
    }, {name: '实验场地'}, {name: '资源检索数据'}, {name: '仿真卫星'}
]

class Guide extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: 0,
            backGroundImgTitle: '',
            notices: [{
                content: '近日，蟹老板成功研发了新型的美味蟹黄堡，比基尼海滩的各位居民纷纷闻讯而来...',
                title: '公告1'
            },
                {content: '1907年2月2日，俄国著名化学家门捷列夫逝世，享年73岁...', title: '公告2'},],
            training: [],

            searchValue: "",

            nowPositionName: "",
            provinceName: "",
            cityName: "",
            townName: "",
            nowPosition: [0, 0, 0, 0],

            introduceDatas: {
                image: "",
                precedent: "",
                title: "",
                content: ""
            },
            newsDatas: {
                image: "",
                title: "",
                time: "",
                content: ``
            },
            // 0-卫星 1-数据 2-工具 3-站点数据 4-卫星数据 5-产品
            statisticsDatas: [
                {
                    num: "",
                    type: "颗",
                    name: "遥感卫星",
                    icon: "images/tempImgs/走马灯/统计/1.png"
                },
                {
                    num: "",
                    type: "条",
                    name: "真值数据",
                    icon: "images/tempImgs/走马灯/统计/5.png"
                },
                {
                    num: "",
                    type: "TB",
                    name: "卫星数据",
                    icon: "images/tempImgs/走马灯/统计/5.png"
                },
                {
                    num: "",
                    type: "TB",
                    name: "数据存量",
                    icon: "images/tempImgs/走马灯/统计/4.png"
                },
                {
                    num: "",
                    type: "景",
                    // name: "影像产品",
                    name: "共性产品",
                    icon: "images/tempImgs/走马灯/统计/2.png"
                },
                {
                    num: "",
                    type: "个",
                    name: "模型工具",
                    icon: "images/tempImgs/走马灯/统计/3.png"
                },
            ],
            resourcesCollectLastCardList: [
                {
                    num: "",
                    type: "景",
                    // name: "影像产品",
                    name: "共性产品",
                },
                {
                    num: "",
                    type: "个",
                    name: "模型工具",
                },
                {
                    num: "",
                    type: "TB",
                    name: "数据存量",
                },
                {
                    num: "",
                    type: "景",
                    name: "卫星数据",
                },
                // {
                //     num: "",
                //     type: "",
                //     name: "站点数据条目",
                // },
            ],
            isLogin: false,
            statistics: {visit: 0, prodNum: 0, satDataSum: 0, siteDataNum: 0}
        }
        this.timer2 = {}
        this.timer4 = null
    }

    shouldComponentUpdate(nextProps, nextState) {
        let nextStatistics = nextState.statistics
        let statistics = this.state.statistics
        if (nextStatistics.OnlineCout !== statistics.OnlineCout) {
            let domVisit = document.getElementById('OnlineCout')
            domVisit.classList.add('Guide_TopCarousel_right_block_item_num_animation_active')
            domVisit.addEventListener('animationend', function () {
                // 动画结束后移除动画类
                domVisit.classList.remove('Guide_TopCarousel_right_block_item_num_animation_active');
            });
        }

        if (nextStatistics.prodNum !== statistics.prodNum) {
            let domVisit = document.getElementById('prodNum')
            domVisit.classList.add('Guide_TopCarousel_right_block_item_num_animation_active')
            domVisit.addEventListener('animationend', function () {
                // 动画结束后移除动画类
                domVisit.classList.remove('Guide_TopCarousel_right_block_item_num_animation_active');
            });
        }

        if (nextStatistics.satDataSum !== statistics.satDataSum) {
            let domVisit = document.getElementById('satDataSum')
            domVisit.classList.add('Guide_TopCarousel_right_block_item_num_animation_active')
            domVisit.addEventListener('animationend', function () {
                // 动画结束后移除动画类
                domVisit.classList.remove('Guide_TopCarousel_right_block_item_num_animation_active');
            });
        }

        if (nextStatistics.siteDataNum !== statistics.siteDataNum) {
            let domVisit = document.getElementById('siteDataNum')
            domVisit.classList.add('Guide_TopCarousel_right_block_item_num_animation_active')
            domVisit.addEventListener('animationend', function () {
                // 动画结束后移除动画类
                domVisit.classList.remove('Guide_TopCarousel_right_block_item_num_animation_active');
            });
        }


        return true
    }

    async componentDidMount() {
        this.getBackground()
        if (this.props.location.search) {
            localStorage.clear();
            window.client && window.client.destroy()
            let token = this.props.location.search.split("?token=")?.[1]
            await this.props.login(token)
        }
        this.getNoticeDatas()
        let notices = await getNotice()
        if (notices && notices.length > 0) {
            // debugger
            // notices.push(notices[0])
            this.setState({notices: notices})
            console.log(notices)
        }
        let training = await getTraning(1, 5)
        if (training && training.length > 0) {
            this.setState({training: training})
            console.log(training)
        }

        // let count = 10000;
        // let timer = setInterval(() => {
        //     if (count <= 0) clearInterval(timer);
        //     if (window.earth && window.Geovis && window.earth.scene) {
        //         this.returnNowPosition2();
        //         // crtWMTSLayer();
        //         window.earth.scene.mode = window.Geovis.SceneMode.SCENE2D;
        //         clearInterval(timer);
        //     }
        //     count -= 1;
        // }, 10)

        // 获取卫星数据
        this.timer2 = setInterval(() => {
            axios.get(global.gatewayip + "/api/interface/api/getSatProdToolData").then(
                r => {
                    // console.log("卫星数据信息：", r.data.payload);
                    let data = r.data.payload;
                    this.setState({initData: r.data.payload});
                    let resource = this.state.resourcesCollectLastCardList;
                    let staticResource = this.state.statisticsDatas;
                    // 原statisticsDatas 0-卫星 1-产品 2-工具 3-数据 4-服务卫星数据 5-站点条目数据
                    // 0-卫星 1-数据 2-工具 3-站点数据 4-卫星数据 5-产品
                    staticResource[0].num = data.satNum;//设置卫星数量
                    resource[0].num = data.prodNum;//设置产品数量
                    staticResource[4].num = resource[0].num;
                    resource[1].num = data.toolNul;//设置工具数量
                    staticResource[5].num = resource[1].num;
                    // 设置数据量
                    let dataSize = data.dataSum;
                    resource[2] = this.getDataSize(resource[2], dataSize);
                    staticResource[3] = this.getDataSize(staticResource[3], dataSize);
                    // console.log('检查数据获取及初始化', resource[2], staticResource[3])
                    // 设置卫星数据
                    let setDataSize = data.satDataSum;
                    resource[3].num = data.satDataSum;
                    // staticResource[4] = this.getDataSize(staticResource[4], setDataSize);//单位为景？
                    staticResource[2].num = setDataSize / 10000
                    staticResource[2].type = "万景"
                    let {siteDataNum} = data;
                    // resource[4] = this.getDataSize(resource[4], siteDataNum);
                    // staticResource[5] = this.getDataSize(staticResource[5], siteDataNum);
                    if (siteDataNum > 10000) {
                        staticResource[1].type = '万条';
                        staticResource[1].num = Math.round(siteDataNum / 10000);
                    }
                    this.setState({resourcesCollectLastCardList: resource, statisticsDatas: [...staticResource]});
                    clearInterval(this.timer2)
                }
            )
        }, 1000);
        this.timer3 = setInterval(() => {
            axios.get(`${global.url.news}/news/page2?limit=2&page=1`).then(
                r => {
                    if (r.data.code === '200') {
                        let data = r.data.payload.records;
                        let news1 = data[0], news2 = data[1];
                        let newsDatas = {
                            image: news1.thumbnail,
                            title: news1.title,
                            time: news1.created.slice(0, 10),
                            content: news1.summary
                        }
                        let introduceDatas = {image: news2.thumbnail, title: news2.title, content: news1.summary}
                        this.setState({introduceDatas: introduceDatas, newsDatas: newsDatas});
                        clearInterval(this.timer3)
                    }
                }
            )
        }, 1000);
        this.getVisits()
    }

    getBackground = () => {
        // 获取背景图片
        {
            const guideTopBackground = document.querySelector('.Guide_TopBackground');
            // 设置默认背景图片或样式
            guideTopBackground.style.backgroundImage = 'linear-gradient(180deg, rgba(0, 114, 229, 0.2) 0%, rgba(0, 0, 0, 0.6) 100%), url(default-image.jpg)';

            // 从本地存储获取数据
            const storedHeadMes = localStorage.getItem('HeadMes');
            if (storedHeadMes) {
                const headMes = JSON.parse(storedHeadMes);
                const imageUrl = headMes.backGroundImgUrl;
                this.setState({backGroundImgTitle: headMes.backGroundImgTitle})
                if (imageUrl) {
                    guideTopBackground.style.backgroundImage = `linear-gradient(180deg, rgba(0, 114, 229, 0.2) 0%, rgba(0, 0, 0, 0.6) 100%), url(${imageUrl})`;
                }
            } else {
                console.log('No data found in localStorage for key "HeadMes"');
            }
        }
    }

    // getVisits = async () => {
    //
    //     this.getSatProdToolDatasTimer=setInterval(()=>{
    //         axios.get('/gateway/api/interface/api/getSatProdToolDatas').then(res => {
    //             this.setState({
    //                     statistics: res.data.payload
    //                 }, () => {
    //                     clearInterval(this.getSatProdToolDatasTimer)
    //                     // setTimeout(() => {
    //                     //     this.getVisits()
    //                     // }, 1000)
    //                 }
    //             )
    //         }).catch(e => {
    //             // setTimeout(() => {
    //             //     this.getVisits()
    //             // }, 1000)
    //         })
    //     },1000)
    //
    //
    //
    //
    //     // await axios.get('/gateway/api/interface/api/getSatProdToolDatas').then(res => {
    //     //     this.setState({
    //     //             statistics: res.data.payload
    //     //         }, () => {
    //     //             setTimeout(() => {
    //     //                 this.getVisits()
    //     //             }, 1000)
    //     //         }
    //     //     )
    //     // }).catch(e => {
    //     //     setTimeout(() => {
    //     //         this.getVisits()
    //     //     }, 1000)
    //     // })
    //

    getVisits = () => {
        // 定义递归请求函数
        const fetchData = () => {
            axios.get('/gateway/api/interface/api/getSatProdToolDatas')
                .then(res => {
                    this.setState({
                        statistics: res.data.payload
                    }, () => {
                        // 成功更新数据后，1秒后发起下一次请求
                        this.pollingTimer = setTimeout(fetchData, 1000);
                    });
                })
                .catch(e => {
                    // 请求失败后，1秒后重试
                    this.pollingTimer = setTimeout(fetchData, 1000);
                });
        };

        // 清除已有定时器（安全防护）
        if (this.pollingTimer) {
            clearTimeout(this.pollingTimer);
        }

        // 立即发起首次请求
        fetchData();
    };
    getDataSize = (item, dataSizeNum) => {
        let GB = 1048576;//换算原数据有多少GB
        let TB = 1073741824;//换算原始数据有多少TB
        let newItem = {...item}
        if (dataSizeNum / TB < 100) {
            newItem.type = "GB";
            newItem.num = (dataSizeNum / GB).toFixed(2);
        } else {
            newItem.num = (dataSizeNum / TB).toFixed(2);
            newItem.type = "TB";
        }
        return newItem;
    }

    componentWillUnmount() {
        clearInterval(this.timer4)
        if (this.pollingTimer) {
            clearTimeout(this.pollingTimer);
        }
    }

    onsearch = () => {
        this.props.history.push({
            pathname: './GuideSearch', state: {
                searchvalue: this.state.searchValue,
            }
        })
    }
    getNoticeDatas = () => {
        Axios.get(global.url.news + "/notice/getNotices/1/1").then((response) => {
            // console.log('11111111111111111111111111111', response)
        }).catch(() => {
        })
    }
    searchOnChange = (e) => {
        this.setState({searchValue: e.target.value});
    }
    checkmenu = (i) => {
        this.setState({checked: i})
    }

    // 处理公告内容，去除标签和行尾空格
    filterHtmlTag = (str) => {
        let content = str.replace(/<\/?[^>]*>/g, "")  //去除标签
        content = content.replace(/[|]*\n/, "");//去除行尾空格
        return content;
    }

    //处理menuCard的跳转
    menuCardJump = (address) => {
        console.log("menuCardJump", address);
    }

    //返回当前地理位置（控制在2维球上显示）
    // returnNowPosition = async () => {
    //     let nowPos = "中国/北京市/市辖区/东城区"
    //     let provinceName = "北京市";
    //     let cityName = "市辖区";
    //     let townName = "东城区";
    //     let nowGeom = await searchAdminDivisionJson_zd(nowPos, this.props.zd_user.token);
    //     let nowPosition = getPositionsFromAdminDivisionData_zd(nowGeom);
    //     // console.log("returnNowPosition", nowPosition, nowGeom);
    //     this.flyToPosition(nowPosition);
    //     this.setState({provinceName: provinceName, cityName: cityName, townName: townName, nowPosition: nowPosition});
    // }
    //返回当前地理位置（控制在2维球上显示）
    // returnNowPosition2 = async () => {

    //     let nowPos = ""
    //     let provinceName = "北京2021年5月2日1米分辨率影像";
    //     let cityName = "";
    //     let townName = "";
    //     let nowPosition = [116.50347360364503, 40.23798410645239, 116.71592960364503, 40.3996010645239];
    //     // showTiff({url:"/getGuideLayer/geoserver/gwc/service/tms/1.0.0/ksh%3ABeijing_20210502_1m@EPSG%3A4490@png"},true)
    //     // showTiff({url:"images/Tiff/ksh-Beijing_20210502_1m.tif"},true)
    //     var wmtsImageryProvider = new window.Geovis.WebMapTileServiceImageryProvider({
    //         // http://10.0.30.34:18070/geoserver/gwc/service/wmts?layer=ksh%3ABeijing_20210502_1m&style=&tilematrixset=EPSG%3A4326&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A4326%3A10&TileCol=1687&TileRow=282
    //         url: "/getGuideLayer/geoserver/gwc/service/wmts",
    //         // url: "http://10.0.30.34:18070/geoserver/gwc/service/wmts",
    //         layer: "ksh:Beijing_20210502_1m", //图层名称，如：'tasmania'
    //         style: '',
    //         format: 'image/png',
    //         tileMatrixSetID: 'EPSG:4326',
    //         tileMatrixLabels: ['EPSG:4326:0', 'EPSG:4326:1', 'EPSG:4326:2', 'EPSG:4326:3', 'EPSG:4326:4', 'EPSG:4326:5', 'EPSG:4326:6', 'EPSG:4326:7', 'EPSG:4326:8', 'EPSG:4326:9', 'EPSG:4326:10', 'EPSG:4326:11', 'EPSG:4326:12', 'EPSG:4326:13', 'EPSG:4326:14', 'EPSG:4326:15', 'EPSG:4326:16', 'EPSG:4326:17', 'EPSG:4326:18', 'EPSG:4326:19',],
    //         tilingScheme: new window.Geovis.GeographicTilingScheme(),
    //     });
    //     window.earth.imageryLayers.addImageryProvider(wmtsImageryProvider)

    //     this.flyToPosition(nowPosition, 6000);
    //     this.setState({provinceName: provinceName, cityName: cityName, townName: townName, nowPosition: nowPosition});
    // }
    flyToPosition = async (data, height = 50000) => {
        let positions = [0, 0, 0, 0]
        positions = await data;
        if (positions) {
            window.earth.camera.setView({
                destination: window.Geovis.Cartesian3.fromDegrees((positions[0] + positions[2]) / 2.0, (positions[1] + positions[3]) / 2.0, height)
            })
        }
    }

    handleNum = (num) => {
        if (num)
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        else return 0
    }

    render() {
        const {provinceName, cityName, townName, nowPosition, backGroundImgTitle} = this.state;
        return (
            <div>
                <Header4 ref="header4"></Header4>
                <div className='Guide'>
                    <div className='GuideMain'>
                        <div className='Guide_TopBackground'>
                            {/* <img className='Guide_TopBackground_Img' src={homePageImg} /> */}
                            {/* <Globe isGuideFlag={true}/> */}

                            {/* <div className='Guide_TopBackground_Img' style={{ background: `linear-gradient(0deg, rgba(0, 114, 229, 0.2), rgba(0, 0, 0, 0.6)),url(${homePageImg})` }}/> */}
                            {/* <div className='Guide_TopBackground_ImgVein1' />
                            <div className='Guide_TopBackground_ImgVein2' />
                            <div className='Guide_TopBackground_ImgVein3' /> */}
                        </div>

                        <div className='Guide_Search'>
                            {/*<Input*/}
                            {/*    className='Guide_SearchContent'*/}
                            {/*    placeholder="请输入关键字"*/}
                            {/*    size="large"*/}
                            {/*    onChange={this.searchOnChange}*/}
                            {/*    onPressEnter={this.onsearch}*/}
                            {/*/>*/}
                            {/*<div className='Guide_SearchButtons' onClick={this.onsearch}>*/}
                            {/*    <SearchOutlined/>*/}
                            {/*    <div className='Guide_SearchButton'>检索</div>*/}
                            {/*</div>*/}
                        </div>

                        <div className='Guide_TopCarousel'>
                            <GuideCarousel noticeDatas={noticeDatas}
                                           newsDatas={this.state.newsDatas}
                                           statisticsDatas={this.state.statisticsDatas}
                                           introduceDatas={this.state.introduceDatas}
                            />
                            {/* <Carousel className='Guide_TopCarouselMain' >
                                <div className='Guide_TopCarouselContent'>
                                    1
                                </div>
                                <div className='Guide_TopCarouselContent'>
                                    2
                                </div>
                                <div className='Guide_TopCarouselContent'>
                                    3
                                </div>
                            </Carousel> */}
                            {/*<div className='Guide_TopCarousel_BackgroundInfo'>*/}
                            {/*    <div className='Guide_TopCarousel_BackgroundInfoContent'>*/}
                            {/*        <div className='Guide_TopCarousel_BackgroundInfo_Img'><SearchOutlined /></div>*/}
                            {/*        <div className='Guide_TopCarousel_BackgroundInfoContentText'>*/}
                            {/*            <div className='Guide_TopCarousel_BackgroundInfo_Name'>长白山</div>*/}
                            {/*            <div className='Guide_TopCarousel_BackgroundInfo_Sat'>{`GF2(PMS)`}</div>*/}
                            {/*            <div className='Guide_TopCarousel_BackgroundInfo_Time'>{`拍摄时间:2021-05-19`}</div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className='Guide_TopCarousel_right'>
                                <div className='Guide_TopCarousel_right_title_wrap'>
                                    <div className='Guide_TopCarousel_right_title'>网站访问量</div>
                                    <DigitalScrolling num={this.state.statistics.visit}/>
                                </div>
                                <div className='Guide_TopCarousel_right_block'>
                                    <div className='Guide_TopCarousel_right_block_item'>
                                        <img src='images/tempImgs/走马灯/统计/5.png'
                                             className='Guide_TopCarousel_right_block_item_img'></img>
                                        <div className='Guide_TopCarousel_right_block_item_text_wrap'>
                                            <div className='Guide_TopCarousel_right_block_item_text'>真值数据</div>
                                            <div className='Guide_TopCarousel_right_block_item_num'>
                                                {this.handleNum(this.state.statistics.siteDataNum)}
                                                <span className='Guide_TopCarousel_right_block_item_num_unit'>
                                                    条
                                                    <div className='Guide_TopCarousel_right_block_item_num_animation'
                                                         id='siteDataNum'>+1</div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='Guide_TopCarousel_right_block_item'>
                                        <img src='images/tempImgs/走马灯/统计/2.png'
                                             className='Guide_TopCarousel_right_block_item_img'></img>
                                        <div className='Guide_TopCarousel_right_block_item_text_wrap'>
                                            <div className='Guide_TopCarousel_right_block_item_text'>卫星数据</div>
                                            <div className='Guide_TopCarousel_right_block_item_num'>
                                                {this.handleNum(this.state.statistics.satDataSum)}
                                                <span className='Guide_TopCarousel_right_block_item_num_unit'>
                                                    景
                                                    <div className='Guide_TopCarousel_right_block_item_num_animation'
                                                         id='satDataSum'>+1</div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='Guide_TopCarousel_right_block_item'>
                                        <img src='images/tempImgs/走马灯/统计/3.png'
                                             className='Guide_TopCarousel_right_block_item_img'></img>
                                        <div className='Guide_TopCarousel_right_block_item_text_wrap'>
                                            {/*<div className='Guide_TopCarousel_right_block_item_text'>影像产品</div>*/}
                                            <div className='Guide_TopCarousel_right_block_item_text'>共性产品</div>
                                            <div className='Guide_TopCarousel_right_block_item_num'>
                                                {this.handleNum(this.state.statistics.prodNum)}
                                                <span className='Guide_TopCarousel_right_block_item_num_unit'>
                                                    景
                                                    <div className='Guide_TopCarousel_right_block_item_num_animation'
                                                         id='prodNum'>+1</div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='Guide_TopCarousel_right_block_item'>
                                        <img src='images/tempImgs/走马灯/统计/1.png'
                                             className='Guide_TopCarousel_right_block_item_img'></img>
                                        <div className='Guide_TopCarousel_right_block_item_text_wrap'>
                                            <div className='Guide_TopCarousel_right_block_item_text'>在线用户数</div>
                                            <div className='Guide_TopCarousel_right_block_item_num'>
                                                {this.handleNum(this.state.statistics.OnlineCout)}
                                                <span className='Guide_TopCarousel_right_block_item_num_unit'>
                                                    个
                                                    <div className='Guide_TopCarousel_right_block_item_num_animation'
                                                         id='OnlineCout'>+1</div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='Guide_TopCarousel_BackgroundInfo'>
                            <div className='Guide_TopCarousel_BackgroundInfoContent'>
                                {/*<div className='Guide_TopCarousel_BackgroundInfo_Img'><SearchOutlined/></div>*/}
                                <div className='Guide_TopCarousel_BackgroundInfoContentText'>
                                    {/*<div className='Guide_TopCarousel_BackgroundInfo_Name'>长白山</div>*/}
                                    {/*<div className='Guide_TopCarousel_BackgroundInfo_Sat'>{`GF2(PMS)`}</div>*/}
                                    <div className='Guide_TopCarousel_BackgroundInfo_Sat'>{backGroundImgTitle}</div>
                                    {/*<div className='Guide_TopCarousel_BackgroundInfo_Time'>{`拍摄时间:2021-05-19`}</div>*/}
                                    {/* <div className='Guide_TopCarousel_BackgroundInfo_Name'>{provinceName}</div>
                                    <div
                                        className='Guide_TopCarousel_BackgroundInfo_Sat'>{cityName !== "市辖区" ? cityName : null}</div>
                                    <div className='Guide_TopCarousel_BackgroundInfo_Sat'>{townName}</div> */}
                                </div>
                            </div>
                        </div>

                        <div className='Guide_MenuCardList'>
                            {menuCardList.map((data) => {
                                return (
                                    <div className='Guide_MenuCard'>
                                        <MenuCard data={data} menuCardJump={this.menuCardJump}/>
                                    </div>
                                )
                            })}
                        </div>

                        <div className='Guide_ResourcesAndKnowledge'>
                            <div className='Guide_Resources'>
                                <GuideMainCard name={"资源汇集"}>
                                    <div className='Guide_ResourcesContent'>
                                        {resourcesCollectCardList.map((data) => {
                                            return (
                                                <ResourcesCollectCard data={data}/>
                                            )
                                        })}
                                        <div className='Guide_ResourcesLastCardList'>
                                            {this.state.resourcesCollectLastCardList.map((data, index) => {
                                                return (
                                                    <GuideResourcesLastCard data={data} index={index}/>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </GuideMainCard>
                            </div>
                            <div className='Guide_Knowledge'>
                                <GuideMainCard name={"培训知识"}>
                                    <div className='Guide_KnowledgeContent'>
                                        {cultivateKnowledgeCardList.map((data) => {
                                            return (
                                                <CultivateKnowledgeCard data={data}/>
                                            )
                                        })}
                                    </div>
                                </GuideMainCard>
                            </div>
                        </div>

                        <div className='Guide_Share'>
                            <GuideMainCard name={"资源共享"}>
                                <div className='Guide_ShareContent'>
                                    {resourcesShareCardList.map((data) => {
                                        return (
                                            <ResourcesShareCard data={data}/>
                                        )
                                    })}
                                </div>
                            </GuideMainCard>
                        </div>

                        <div className='Guide_Service'>
                            <GuideMainCard name={"技术服务"}>
                                <div className='Guide_ServiceContent'>
                                    {technologyServiceCardList.map((data) => {
                                        return (
                                            <TechnologyServiceCard data={data}/>
                                        )
                                    })}
                                </div>
                            </GuideMainCard>
                        </div>
                    </div>
                </div>
                <MainBottom data={unitsList}/>
                <OnlineService></OnlineService>
            </div>
        )
    }
}

//主要卡片框架----2023.04.10
const GuideMainCard = (props) => {
    return (
        <div className='GuideMainCard'>
            <div className='GuideMainCard_Title'>
                <div className='GuideMainCard_TitleText'>{props.name}</div>
                <div className='GuideMainCard_TitleBottom'/>
            </div>
            <div className='GuideMainCard_Content'>
                {props.children}
            </div>
        </div>
    )
}

//资源汇集----2023.04.10
const GuideResourcesLastCard = (props) => {
    const {data, index} = props;
    let url = index === 1 || index === 2 ? 'images/tempImgs/lastCard2.png' : 'images/tempImgs/lastCard1.png'
    return (
        <div className={index === 1 || index === 2 ? 'GuideResourcesLastCard1' : 'GuideResourcesLastCard2'}>
            <div className='GuideResourcesLastCard_Title'>
                <div className='GuideResourcesLastCard_TitleText'>{data.num}</div>
                <div className='GuideResourcesLastCard_TitleType'>{data.type}</div>
            </div>
            <div className='GuideResourcesLastCard_Content'>{data.name}</div>
            <img className='GuideResourcesLastCard_Img1' src={url}/>
            <img className='GuideResourcesLastCard_Img2' src={url}/>
            <img className='GuideResourcesLastCard_Img3' src={url}/>
            <img className='GuideResourcesLastCard_Img4' src={url}/>
        </div>
    )
}
const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
const mapDispatch = (dispatch, ownProps) => ({
    login: async (transferToken) => {
        await dispatch(login({}, transferToken))
    },
})

export default connect(mapState, mapDispatch)(Guide);

function showTiff(map, checked) {
    if (checked) {
        console.log("showTiff", map, map.url);
        // map.picLayer = new window.GeoVis.GeoTiffLayer(map.url, {
        //     samples: [0, 1, 2],
        //     extensions: 'png',
        //     noData: [255, 255, 255]
        // }).addTo(window.earth.layers);

        try {
            map.picLayer = new window.GeoVis.GeoTiffLayer(map.url, {
                samples: [0, 1, 2],
                extensions: 'png',
                noData: [255, 255, 255],
                sampleType: 'single',
                colors: ["#000000", "#FFFFFF"],
                isGradiant: true,
                alpha: 255,
            }).addTo(window.earth.layers);

            // console.log("showTiff", map.picLayer);
            message.info("TIFF数据加载中，请稍等……");
            let isready = false;
            let timer = setInterval(() => {
                isready = map.picLayer.imageryProvider.ready;
                if (isready) {
                    message.success("TIFF数据加载完成！");
                    let rectangle = map.picLayer.imageryProvider.tilingScheme._rectangle;
                    const westMostLong = window.GeoVis.Math.toDegrees(rectangle.west);
                    const eastMostLong = window.GeoVis.Math.toDegrees(rectangle.east);
                    const southMostLat = window.GeoVis.Math.toDegrees(rectangle.south);
                    const northMostLat = window.GeoVis.Math.toDegrees(rectangle.north);

                    const pointLon = (westMostLong + eastMostLong) / 2;
                    const pointLat = (southMostLat + northMostLat) / 2;
                    window.earth.camera.flyTo({
                        destination: window.GeoVis.Cartesian3.fromDegrees(pointLon, pointLat, 50000.0)
                    })
                    clearInterval(timer);
                }
            }, 500);
        } catch (error) {
            console.log(error);
        }
    } else {
        window.earth.layers.remove(map.picLayer);
    }
}

// /** 加载wmts图层
//  * @param attr
//  * @returns {TileLayer}
//  */
// export function crtWMTSLayer({
// 	title = '',
// 	name = '',
// 	value = '',
// 	opacity = '',
// 	zIndex = 10000,
// 	extent = undefined,
// 	host = ''
// } = {}) {
// 	// 切片名
// 	const gridNames = [
// 		'EPSG:4326:0',
// 		'EPSG:4326:1',
// 		'EPSG:4326:2',
// 		'EPSG:4326:3',
// 		'EPSG:4326:4',
// 		'EPSG:4326:5',
// 		'EPSG:4326:6',
// 		'EPSG:4326:7',
// 		'EPSG:4326:8',
// 		'EPSG:4326:9',
// 		'EPSG:4326:10',
// 		'EPSG:4326:11',
// 		'EPSG:4326:12',
// 		'EPSG:4326:13',
// 		'EPSG:4326:14',
// 		'EPSG:4326:15',
// 		'EPSG:4326:16',
// 		'EPSG:4326:17',
// 		'EPSG:4326:18',
// 		'EPSG:4326:19'
// 	];
// 	// 切片大小
// 	const resolutions = [
// 		0.703125,
// 		0.3515625,
// 		0.17578125,
// 		0.087890625,
// 		0.0439453125,
// 		0.02197265625,
// 		0.010986328125,
// 		0.0054931640625,
// 		0.00274658203125,
// 		0.001373291015625,
// 		0.0006866455078125,
// 		0.0003433227539062,
// 		0.0001716613769531,
// 		0.0000858306884766,
// 		0.0000429153442383,
// 		0.0000214576721191,
// 		0.0000107288360596,
// 		0.0000053644180298,
// 		0.0000026822090149,
// 		0.0000013411045074
// 	];
// 	// 设置地图投影
// 	const projection = new window.Projection({
// 		code: 'EPSG:4326', // 投影编码
// 		units: 'degrees',
// 		axisOrientation: 'neu'
// 	});

// 	const NewLayer = new window.Tile({
// 		name: name,
// 		title: title || name,
// 		type: 'Group',
// 		preload: true,
// 		opacity: opacity || 1,
// 		source: new window.WMTS({
// 			url: host + '/gwc/service/wmts',
// 			// name: name,
// 			tileGrid: new window.WMTSTileGrid({
// 				tileSize: [256, 256],
// 				extent: extent === undefined ?
// 					[-180.0, -90.0, 180.0, 90.0] :
// 					extent, // 范围
// 				origin: [-180.0, 90.0],
// 				resolutions: resolutions,
// 				matrixIds: gridNames
// 			}),
// 			matrixSet: 'EPSG:4326',
// 			layer: value,
// 			format: 'image/png',
// 			projection: projection
// 		}),
// 		zIndex: zIndex
// 	});

// 	return NewLayer;
// }